import React from 'react';

const CompanyDraftPage = React.lazy(
  () => import('../../../modules/companies/companyDraft'),
);

export const companyDraftConfig = [
  {
    path: '/create-company/:token',
    element: <CompanyDraftPage />,
  },
];
